import { MainLayout } from "src/apps/commons/layouts";
import { CreateFormContainers } from "src/apps/modules/adminUser";

const Page = () => <CreateFormContainers />;

Page.Layout = MainLayout;

export default Page;
